module.exports = __webpack_public_path__ + "img/Technology Partner-2.5388542b.png";